module.exports = __webpack_public_path__ + "img/SafetyPlanner_logo.9bf8ea38.jpg";